import {
  TableRow,
  TableCell,
  TableBody as SanlamTableBody
} from '@sanlam-glacier/app-common/components';
import { PropsWithChildren } from 'react';

type TableBodyProps<T = Record<string, string>> = {
  rows: T[];
  renderRow: (row: T, index: number) => JSX.Element | null;
};

export const TableBody = <T,>({
  rows,
  renderRow,
  children
}: PropsWithChildren<TableBodyProps<T>>) => {
  if (rows.length === 0) {
    return (
      <SanlamTableBody>
        <TableRow data-testid={`row-${1}`}>
          <TableCell>No data to display</TableCell>
        </TableRow>
      </SanlamTableBody>
    );
  }

  return (
    <SanlamTableBody>
      {rows.map(renderRow)}
      {children}
    </SanlamTableBody>
  );
};
